import React, { useEffect, useRef } from 'react';

declare global {
  interface Window {
    render: (text: string, options?: { htmlTags?: boolean }) => string;
  }
}

interface RenderProps {
  text: string;
  options?: {
    htmlTags?: boolean;
    // Add other options as needed
  };
}

const MathpixRenderer: React.FC<RenderProps> = ({ text, options = { htmlTags: true } }) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (contentRef.current && window.render) {
      const html = window.render(text, options);
      contentRef.current.innerHTML = html;
    }
  }, [text, options]);

  return <div ref={contentRef}  />;
};

export default MathpixRenderer;